var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLineImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 27,
    viewBox: "0 0 159 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.27441 24.0029C10.9173 19.2282 25.4585 9.15787 38.4805 7.07435C54.7579 4.46995 73.0477 9.10644 76.8953 14.2364C78.8486 16.8407 76.8953 23.6781 83.4063 25.3058C88.6151 26.608 108.544 21.0902 114.008 16.8407C119.868 12.283 125.728 7.72618 132.239 3.16828C135.817 0.663487 147.865 0.563882 151.121 5.77267",
    stroke: "#4FAB8C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83218 17.4926C9.83218 20.0098 5.27449 24.6547 5.27449 24.6547C5.27449 24.6547 0.716797 20.0098 0.716797 17.4926C0.716797 14.9755 2.75735 12.9349 5.27449 12.9349C7.79163 12.9349 9.83218 14.9755 9.83218 17.4926Z",
    fill: "#F54C75"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M158.283 12.2838C158.283 14.801 153.725 19.4459 153.725 19.4459C153.725 19.4459 149.167 14.801 149.167 12.2838C149.167 9.76668 151.208 7.72613 153.725 7.72613C156.242 7.72613 158.283 9.76668 158.283 12.2838Z",
    fill: "#F54C75"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineImage);
export default __webpack_public_path__ + "static/media/line_image.756a0cae8f173be878acafdccc1d9042.svg";
export { ForwardRef as ReactComponent };